import { surveyMappingValidationConstants as constants } from '../Constants/validationConstants'
import { validateEmail } from '../helper/util'
class SurveyMappingValidation {
  version
  errMap
  valid

  constructor() {
    if (!SurveyMappingValidation.instance) {
      this.version = 0
      this.valid = true
      this.errMap = new Map()
      SurveyMappingValidation.instance = this
    }
    return SurveyMappingValidation.instance
  }

  validateSavedData(savedData, createMode) {
    this.resetErrorMessages()
    this.validateObj(savedData, createMode)
    this.version++
  }

  validateObj(savedData, createMode) {

    if (!savedData.surveyId) {
      this.setErrMsgMap(constants.KEY_SURVEY_ID, 'Missing Survey ID')
    }

    if (!savedData.serviceType) {
      this.setErrMsgMap(constants.KEY_SERVICE_TYPE, 'Missing Service Type')
    }

    if (!savedData.surveyType) {
      this.setErrMsgMap(constants.KEY_SURVEY_TYPE, 'Missing Survey Type')
    }

    if (!(typeof savedData.mandatory == 'boolean')) {
      this.setErrMsgMap(constants.KEY_MANDATORY, 'Missing Mandatory')
    }
    if (!savedData.startTimestamp) {
      this.setErrMsgMap(constants.KEY_START_TIME, 'Missing Start Time')
    }
    if (!savedData.endTimestamp) {
      this.setErrMsgMap(constants.KEY_END_TIME, 'Missing End Time')
    }

  }

  resetErrorMessages() {
    this.errMap = new Map()
    this.valid = true
  }

  getVersion() {
    return this.version
  }

  isValid() {
    return this.valid
  }

  getErrorMessages(key, uniqueKey) {
    if (!uniqueKey) {
      return this.errMap.has(key) ? this.errMap.get(key) : []
    } else {
      return []
    }
  }

  setErrMsgMap(key, errMsg, valid = false) {
    this.errMap.set(key, errMsg)
    if (!valid) {
      this.valid = false
    }
  }
}

const validation = new SurveyMappingValidation()
export default validation
